import React from 'react';
import PropTypes from 'prop-types';
import Box from 'common/src/components/Box';
import Heading from 'common/src/components/Heading';
import Button from 'common/src/components/Button';
import Container from 'common/src/components/UI/Container';

import CTA from './cta.style';

const CTASection = ({
  row,
  col,
  title,
  button,
  textArea,
  imageArea,
  content,
  buttonLink,
  buttonTitle,
}) => {
  return (
    <CTA>
      <Container>
        <Box {...row}>
          <Box {...col} {...imageArea} />
          <Box {...col} {...textArea}>
            <Heading {...title} content={content} />
            <Box>
              <a href={buttonLink}>
                <Button {...button} title={buttonTitle} />
              </a>
            </Box>
          </Box>
        </Box>
      </Container>
    </CTA>
  );
};

CTASection.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  title: PropTypes.object,
  button: PropTypes.object,
  textArea: PropTypes.object,
  imageArea: PropTypes.object,
  content: PropTypes.string,
  buttonLink: PropTypes.string,
  buttonTitle: PropTypes.string,
};

CTASection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
    alignItems: 'center',
  },
  imageAreaRow: {
    flexDirection: 'row-reverse',
  },
  col: {
    pr: '15px',
    pl: '15px',
  },
  textArea: {
    width: ['100%', '100%', '55%', '50%', '42%'],
  },
  imageArea: {
    width: ['100%', '100%', '45%', '50%', '58%'],
    mb: ['40px', '40px', '0', '0', '0'],
  },
  title: {
    fontSize: ['26px', '30px', '30px', '48px', '48px'],
    fontWeight: '400',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '15px',
    lineHeight: '1.25',
  },
  button: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '600',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'secondaryWithBg',
    minWidth: '150px',
  },
};

export default CTASection;
